export enum ApiKeyRequestResult { None, OK, Refused, Expired };

export interface ApiKeyRequestDTO
{
  RequestID: string;
  AuthUrl: string;
  RequestResult: ApiKeyRequestResult;
}
